<template>
  <div class="wrapper">
    <div class="wrapper_left">
      <div class="content">
        <el-form
          ref="Dto"
          :model="chargingPileEditDTO"
          :rules="rules"
          label-width="auto"
        >
          <el-form-item label="设备编号">
            <el-input v-model="chargingPileEditDTO.id" disabled />
          </el-form-item>
          <el-form-item label="硬件UID">
            <el-input v-model="chargingPileEditDTO.ids" disabled />
          </el-form-item>
          <el-form-item label="设备名称" prop="name">
            <el-row>
              <el-col :span="15">
                <el-input
                  v-model="chargingPileEditDTO.name"
                  placeholder="示例：1栋1号机"
                />
              </el-col>
              <!-- <el-col :span="1">
                <div style="text-align: center">-</div>
              </el-col>
              <el-col :span="8">
                <el-input
                  v-model.number="chargingPileEditDTO.plot"
                  placeholder="设备序号"
                />
              </el-col> -->
            </el-row>
          </el-form-item>
          <!-- <el-form-item label="断电设置" prop="powerSettings">
            <el-select
              v-model="chargingPileEditDTO.powerSettings"
              placeholder="请选择"
            >
              <el-option
                v-for="item in outage"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="最大功率" prop="maxPower">
            <el-input-number
              v-model.number="chargingPileEditDTO.maxPower"
              :min="100"
            ></el-input-number
            >&nbsp;&nbsp;瓦
          </el-form-item>
          <el-form-item label="限时充电" prop="chargeMaxTime">
            <el-input-number
              v-model.number="chargingPileEditDTO.chargeMaxTime"
              :min="1"
            ></el-input-number
            >&nbsp;&nbsp;小时
          </el-form-item> -->

          <el-form-item label="主机二维码">
            <div style="text-align: right">
              <template v-if="chargingPileEditDTO.hasDeviceQRCode">
                <!-- <el-button
                  v-if="
                    chargingPileEditDTO.versions != '8' &&
                    chargingPileEditDTO.versions != '9'
                  "
                  type="danger"
                  @click="unBind"
                  >解绑</el-button
                >
                <el-button v-else>已绑定</el-button> -->

                <el-button
                  v-if="
                    chargingPileEditDTO.versions == '2' ||
                    chargingPileEditDTO.versions == '4' ||
                    chargingPileEditDTO.versions == '9'
                  "
                  type="warning"
                  @click="qtBind"
                  >更换</el-button
                >
                <el-button type="info" @click="viewQrcode">查看</el-button>
              </template>

              <el-button v-else type="warning" @click="qtBind">绑定</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_box">
        <el-button type="primary" @click="post">保存设备信息</el-button>
      </div>
    </div>
    <div class="wrapper_line"></div>
    <div class="wrapper_right">
      <!-- <div>
        <div class="right_title">配置充电时间</div>
        <el-form :model="form">
          <el-form-item label="时间类型" prop="resource">
            <el-radio-group v-model="form.select">
              <el-radio label="1">按小时</el-radio> 
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="time-conf">
          <div v-for="(item, index) in list" :key="index" class="select">
            <div :class="{ checked: checked(item) }" @click="change(item)"> 
              {{ item.label }}
            </div>
          </div>
        </div>
        <div v-if="form.select === '1'" class="title">
          (备注：数字为对应的充电时间，单位小时，最长10小时，最多选择6个)
        </div>
      </div>
      <div style="text-align: right">
        <el-button type="primary" @click="editPost">保存充电时长</el-button>
      </div> -->
    </div>

    <!-- 主机二维码弹框 -->
    <el-dialog
      title="主机二维码"
      v-if="showGenerateQrcodeDialog"
      :visible.sync="showGenerateQrcodeDialog"
      :fullscreen="dialogFullscreen"
    >
      <div class="qrcode_wrapper">
        <div ref="qrcodeRef" v-for="item in 1" :key="item" class="qrcode_box">
          <div class="box_title">
            <el-button
              type="primary"
              style="margin-left: 5px"
              @click="handleQrcodeDownLoad(item - 1)"
              >下载图片</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <a id="downloadLink"></a>
  </div>
</template>

<script>
import maintenanceManEditDeviceBaseInfo from "@/maintain/api/device/charging-pile-manage/maintenanceManEditDeviceBaseInfo";
import maintenanceManGetDeviceInfoByDeviceId from "@/maintain/api/device/charging-pile-manage/maintenanceManGetDeviceInfoByDeviceId";
import maintenanceManEditChargeTimeConf from "@/maintain/api/device/charging-time-conf-controler/maintenanceManEditChargeTimeConf";
import maintenanceManGetChargeTimeConf from "@/maintain/api/device/charging-time-conf-controler/maintenanceManGetChargeTimeConf";
import maintainGetQrcodeUrlToGenerate from "@/maintain/api/device/device-qr-code-controler/maintainGetQrcodeUrlToGenerate";
import maintainUnbindDeviceQRCode from "@/maintain/api/device/device-qr-code-controler/maintainUnbindDeviceQRCode";
import maintenanceManChangeDeviceQRCode from "@/maintain/api/device/device-qr-code-controler/maintenanceManChangeDeviceQRCode";

import createdMixin from "@/mixin/createdMixin";
import dialogMixin from "@/mixin/dialogMixin";
import scanMixin from "@/mixin/scanMixin";
import { floatNumber } from "@/utils/check";
import { getQueryArgs } from "@/utils/utils";
import { Message } from "element-ui";
import QRCode from "qrcodejs2";

export default {
  name: "PowerStationDetailOne",
  mixins: [scanMixin, createdMixin, dialogMixin],
  data() {
    return {
      chargingPileEditDTO: {
        powerSettings: "1",
        maxPower: 1000,
        chargeMaxTime: 10,
        costOfPowerFare: 0.5,
        name: "",
        // plot: 0,
        id: undefined,
        ids: undefined,
        hasDeviceQRCode: false,
        versions: "",
      },
      rules: {
        name: [{ required: true, message: "请输入设备名称" }],
        // plot: [
        //   { required: true, message: "请输入设备序号" },
        //   { type: "number", message: "设备序号必须为数数字" },
        //   { validator: noZero },
        // ],
        maxPower: [
          { required: true, message: "请输入最大功率" },
          { type: "number", message: "最大功率必须为数字值" },
        ],
        chargeMaxTime: [
          { required: true, message: "请输入限时充电" },
          { type: "number", message: "限时充电必须为数字值" },
        ],
        costOfPowerFare: [{ required: true, validator: floatNumber }],
      },
      outage: [
        { value: "1", label: "充满自停" },
        { value: "2", label: "误拔断电" },
        { value: "3", label: "定时充电" },
      ],
      form: {
        select: "1",
      },
      records: [
        {
          chargeNum: 0,
        },
        {
          chargeNum: 2,
        },
        {
          chargeNum: 4,
        },
        {
          chargeNum: 6,
        },
        {
          chargeNum: 8,
        },
        {
          chargeNum: 10,
        },
      ],
      editDialog: false,
      list: [],
      showGenerateQrcodeDialog: false,
      editParams: [],
    };
  },
  created() {
    // 获取设备基础信息
    // getDeviceBaseInfoById(this.$route.params.id).then((res) => {
    //   this.chargingPileEditDTO = res.data;
    // });
    // this.fetchChargeTimeData();
  },
  computed: {
    checked() {
      return (val) => {
        return this.records.some((item) => {
          if (val.chargeNum === item.chargeNum) {
            return true;
          }
        });
      };
    },
  },
  watch: {
    "form.select": {
      handler(newValue) {
        console.log(newValue);
        const list = [];
        for (let i = 0; i <= 10; i++) {
          list.push({
            chargeNum: i,
            label: i == 0 ? "充满自停" : i,
          });
        }
        if (newValue === "1") {
          this.list = list;
        } else if (newValue === "2") {
          list.shift();
          this.list = list;
        }
      },
      immediate: true,
    },
  },
  methods: {
    viewQrcode() {
      this.showGenerateQrcodeDialog = true;
      maintainGetQrcodeUrlToGenerate(this.chargingPileEditDTO.id).then(
        (res) => {
          console.log(res);
          this.$nextTick(() => {
            this.generatorQrcodeFn(
              res.data.qrcodeUrl,
              String(res.data.qrcodeId).padStart(6, 0),
              this.$refs.qrcodeRef[0]
            );
          });
        }
      );
    },
    generatorQrcodeFn(qrCodeUrl, qrcodeText, qrcodeDom = null) {
      let qrcodeContent = qrcodeDom || document.createElement("div");
      qrcodeContent.width = "600px";
      qrcodeContent.height = "600px";
      let qrcodeCanvas = new QRCode(qrcodeContent, {
        text: qrCodeUrl, // 需要转换为二维码的内容
        width: 600,
        height: 600,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      let resolutionMultiple = 1; // 分辨率倍数
      let borderSize = 15 * resolutionMultiple; // 边框留白
      let canvasWidth = 600 * resolutionMultiple; // 图片宽度
      // 判断 参数为空的命名情况
      let text = qrcodeText; // 底部文字
      let fontSize = 20 * resolutionMultiple; // 文字大小

      let canvasHeight = canvasWidth + fontSize + 15;
      let canvas = document.createElement("canvas");
      if (!canvas.getContext) return;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;

      let ctx = canvas.getContext("2d");
      ctx.fillStyle = "rgb(255,255,255)"; // 调色(纯白)
      ctx.fillRect(0, 0, canvasWidth, canvasHeight); // 绘制背景

      let qrcodeSize = canvasWidth - borderSize * 2;
      ctx.drawImage(
        qrcodeContent.querySelector("canvas"),
        borderSize,
        borderSize,
        qrcodeSize,
        qrcodeSize
      ); // 填充二维码

      ctx.fill(); // 填充背景

      ctx.fillStyle = "rgb(0,0,0)"; // 调色(纯黑)
      ctx.font = fontSize + "px Arial"; // 文本大小, 字体
      ctx.textAlign = "center";
      ctx.fillText(
        text,
        canvasWidth / 2,
        qrcodeSize + borderSize + fontSize + 15,
        qrcodeSize
      ); // 绘制文本
      // 清除原二维码
      qrcodeCanvas.clear();
      [...qrcodeContent.querySelectorAll("canvas, img")].forEach((e) =>
        e.remove()
      );
      qrcodeContent.appendChild(canvas);
      return qrcodeContent;
    },
    handleQrcodeDownLoad(i) {
      let img = this.$refs.qrcodeRef[i].children[1];
      // 构建画布
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      // 构造url
      let url = canvas.toDataURL("image/png");
      // 构造a标签并模拟点击
      let downloadLink = document.getElementById("downloadLink");
      downloadLink.setAttribute("href", url);
      downloadLink.setAttribute("download", `主机二维码.png`);
      downloadLink.click();
    },
    // post() {
    //   if (this.chargingPileEditDTO.plot) {
    //     this.$refs["Dto"].validate((valid) => {
    //       if (valid) {
    //         this.chargingPileEditDTO.name =
    //           this.chargingPileEditDTO.name +
    //           "-" +
    //           this.chargingPileEditDTO.plot;
    //         let Dto = { ...this.chargingPileEditDTO };
    //         // this.loadStart();
    //         editDevice(Dto, {})
    //           .then((res) => {
    //             // this.resNoDialog({ res });
    //             if (res.code == 1) {
    //               Message.success("保存成功~");
    //             } else {
    //               Message.error(res.msg);
    //             }
    //           })
    //           .finally(() => {
    //             // this.loadDialog.close();
    //           });
    //       }
    //     });
    //   } else {
    //     Message.error("请输入设备序号并大于0");
    //   }
    // },
    unBind() {
      maintainUnbindDeviceQRCode(this.chargingPileEditDTO.id).then((res) => {
        if (res.code == 1) {
          Message.success("解绑成功~");
          this.fetchData();
        } else {
          Message.error(res.msg);
        }
      });
    },
    fetchData() {
      maintenanceManGetDeviceInfoByDeviceId(this.$route.params.id).then(
        (res) => {
          this.chargingPileEditDTO.hasDeviceQRCode = res.data.hasDeviceQRCode;
          this.chargingPileEditDTO.versions = res.data.versions;
          this.chargingPileEditDTO.powerSettings = res.data.powerSettings;
          this.chargingPileEditDTO.id = res.data.id;
          this.chargingPileEditDTO.ids = res.data.ids;
          this.chargingPileEditDTO.name = res.data.name;
          // this.chargingPileEditDTO.plot = right;
          this.chargingPileEditDTO.maxPower = res.data.maxPower;
          this.chargingPileEditDTO.chargeMaxTime = res.data.chargeMaxTime;
          this.chargingPileEditDTO.costOfPowerFare = res.data.costOfPowerFare;
        }
      );
    },
    qtBind() {
      this.scan({
        callBack: (res) => {
          maintenanceManChangeDeviceQRCode(
            getQueryArgs(res.resultStr)["code"].substring(0, 32),
            this.chargingPileEditDTO.id
          ).then((res) => {
            if (res.code == 1) {
              Message.success("绑定成功~");
              this.fetchData();
            } else {
              Message.error(res.msg);
            }
          });
        },
      });
    },
    post() {
      this.$refs["Dto"].validate((valid) => {
        if (valid) {
          let Dto = { ...this.chargingPileEditDTO };
          // Dto.name = Dto.name + "-" + Dto.plot;
          // delete Dto.plot;
          maintenanceManEditDeviceBaseInfo(Dto).then((res) => {
            if (res.code == 1) {
              Message.success("保存成功~");
              this.fetchData();
            } else {
              Message.error(res.msg);
            }
          });
        }
      });
    },
    fetchChargeTimeData() {
      maintenanceManGetChargeTimeConf({ deviceId: this.$route.params.id }).then(
        (res) => {
          this.form.select = String(res.data.timeUnit);
          if (res.data.chargingTimeConfList.length !== 0) {
            this.records = res.data.chargingTimeConfList;
          }
        }
      );
    },
    open() {
      this.editParams = [];
      this.editDialog = true;
      for (const item of this.records) {
        this.editParams.push(item.chargeNum);
      }
    },
    listHas(val) {
      let index;
      for (let i = 0; i < this.records.length; i++) {
        if (val.chargeNum === this.records[i].chargeNum) {
          index = i;
          break;
        }
      }
      this.records.splice(index, 1);
    },
    change(val) {
      let len = this.records.length;
      let judge = this.records.some((item) => {
        if (val.chargeNum === item.chargeNum) {
          return true;
        }
      });
      if (len === 6) {
        if (judge) {
          this.listHas(val);
        }
      } else if (len < 6) {
        if (judge) {
          this.listHas(val);
        } else {
          this.records.push({
            chargeNum: val.chargeNum,
          });
        }
      }
    },
    editPost() {
      let dto = [];
      // todo 有空 改
      for (let i = 0; i < this.records.length; i++) {
        if (this.form.select === "2") {
          if (this.records[i].chargeNum !== 0) {
            dto.push(this.records[i]);
          }
        } else {
          dto.push(this.records[i]);
        }
      }
      let agentEditChargingTimeDTO = {
        chargeTimeConfDTOS: dto,
        id: this.$route.params.id,
        chargeTimeUnit: this.form.select,
      };
      // this.loadStart();
      maintenanceManEditChargeTimeConf(agentEditChargingTimeDTO)
        .then((res) => {
          if (res.code == 1) {
            Message.success("保存成功~");
            this.fetchChargeTimeData();
          } else {
            Message.error(res.msg);
          }
        })
        .finally(() => {
          // this.loadDialog.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/my";
@include mobile {
  div.wrapper {
    display: block;
    .wrapper_right {
      .right_title {
        border-top: 1px dashed #bbb;
        margin-top: 40px;
        padding-top: 20px;
        text-align: center;
      }
    }
    .btn_box {
      margin-top: 10px;
      text-align: right;
    }
  }

  div.select {
    width: 50% !important;
    box-sizing: border-box;
    margin: 10px 0 !important;
    padding: 14px !important;
  }

  div.title {
    margin: 40px 0 30px;
    font-size: 16px;
    text-align: left;
    line-height: 25px;
  }

  .qrcode_wrapper {
    flex-direction: column;
    .qrcode_box {
      margin-bottom: 40px;
      margin-right: 0;
    }
  }
}

.qrcode_wrapper {
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
  .qrcode_box {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    margin-right: 30px;
    .box_title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}

.wrapper {
  display: flex;
  align-items: stretch;
  .wrapper_left {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .wrapper_line {
    width: 1px;
    background: #dcdfe6;
    margin: 0 30px;
  }
  .wrapper_right {
    flex: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .right_title {
      font-weight: bold;
      font-size: 15px;
      color: #409eff;
      margin-bottom: 15px;
    }
  }
}

.time-conf {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.select {
  margin-left: 20px;
  text-align: center;
  height: 80px;
  width: 80px;
  line-height: 80px;
  margin-top: 20px;

  & > div {
    color: #b3b3b3;
    border: 2px solid #b3b3b3;
  }
}

.select + .select {
  margin-left: 20px;
}

.checked {
  color: #ff6600 !important;
  border: 2px solid #ff6600 !important;
}

.title {
  text-align: center;
  font-size: 18px;
  margin-top: 20px;
  color: #606266;
}

@media only screen and (max-width: 768px) {
  main {
    width: 100% !important;
    padding: 0 !important;
  }
  // .select {
  //   padding: 3px !important;
  //   width: 30% !important;
  // }
}
</style>
